export const DEFAULT_LANG_CD = "en";
export const DEFAULT_LANGUAGE = "en";
export const FALLBACK_LANGUAGE = "en";
export const SPEECH_TO_TEXT_SUPPORTED_LANGS = [
  "af",
  "am",
  "ar",
  "be",
  "bg",
  "bn",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "eu",
  "fa",
  "fi",
  "fr",
  "gd",
  "gl",
  "gu",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "iw",
  "ja",
  "jw",
  "ka",
  "km",
  "kn",
  "ko",
  "lo",
  "lt",
  "lv",
  "ml",
  "mr",
  "ms",
  "ne",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "si",
  "sk",
  "sl",
  "sr",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "th",
  "tl",
  "tr",
  "uk",
  "ur",
  "vi",
  "zh-CN",
  "zh-TW",
  "zu",
];
export const SUPPORTED_LANGUAGES = [
  "en",
  "ja",
  "ko",
  "zh-CN",
  "zh-TW",
  "th",
  "ms",
  "id",
  "tl",
  "vi",
  "hi",
  "fr",
  "de",
  "it",
  "ru",
  "es",
  "ar",
  "bn",
  "pt",
  "tr",
  "fa",
  "mn",
  "pl",
  "cs",
  "sv",
  "da",
  "nl",
  "si",
  "km",
  "my",
  "ne",
  "iw",
  "el",
  "af",
  "sq",
  "am",
  "hy",
  "az",
  "eu",
  "be",
  "bs",
  "bg",
  "ca",
  "ceb",
  "co",
  "hr",
  "eo",
  "et",
  "fi",
  "fy",
  "gl",
  "ka",
  "gu",
  "ha",
  "haw",
  "hmn",
  "hu",
  "is",
  "ig",
  "ga",
  "jw",
  "kn",
  "kk",
  "ku",
  "ky",
  "lo",
  "la",
  "lv",
  "lt",
  "mk",
  "mg",
  "ml",
  "mt",
  "mi",
  "mr",
  "no",
  "ps",
  "pa",
  "ro",
  "sm",
  "gd",
  "sr",
  "st",
  "sn",
  "sd",
  "sk",
  "sl",
  "so",
  "su",
  "sw",
  "tg",
  "ta",
  "te",
  "uk",
  "ur",
  "uz",
  "cy",
  "xh",
  "yi",
  "yo",
  "zu",
  "ht",
  "lb",
  "ny",
  "fj",
  "otq",
  "to",
  "ty",
  "yua",
  "kzn",
];
export const RTL_LANGUAGES = ["ar", "fa", "iw", "ur", "ps", "sd", "yi"];

export const SUPPORTED_LANGUAGES_FOR_CUSTOM_DIC = [
  "en",
  "ja",
  "ko",
  "zh-CN",
  "zh-TW",
  "th",
  "ms",
  "id",
  "tl",
  "vi",
  "hi",
  "fr",
  "de",
  "it",
  "ru",
  "es",
  "ar",
  "bn",
  "pt",
  "tr",
  "fa",
  "mn",
  "pl",
  "cs",
  "sv",
  "da",
  "nl",
  "si",
  "km",
  "my",
  "ne",
  "iw",
  "el",
];
